import { move } from './move_cursor';
import type { HEX } from '../types.ts';

export const calculateHue = (e: React.MouseEvent | MouseEvent, container: HTMLDivElement) => {
  const { width, height, left, top } = container.getBoundingClientRect();
  const position = move(e, width, height, left, top);
  return (position.x / width) * 360;
};

export const isValidateHex = (hex: HEX) => {
  const hexPattern = hex.length >= 8 ? /^#?([a-fA-F0-9]{8})$/ : /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
  return hexPattern.test(hex);
};

// Accepts only complete 6-digit or 8-digit hex codes, excluding 3-digit shorthand.
// Use this when committing a colour value so that partially-typed inputs (e.g. 3 chars
// of a 6-char code) are never treated as a complete colour.
export const isCompleteHex = (hex: HEX) => {
  const hexPattern = /^#?([a-fA-F0-9]{8}|[a-fA-F0-9]{6})$/;
  return hexPattern.test(hex);
};
